import { Link } from 'gatsby';
import { palette } from 'src/styles/colors';
import styled from 'styled-components';

export const RatingContainer = styled(Link)`
  display: grid;
  text-decoration: none;
  color: ${palette.text};
  column-gap: 12px;
  grid-template-columns: 110px 82px 80px;
`
